module.exports = __webpack_public_path__ + "static/media/clothing.85654d87.svg";